import React, { FC } from 'react';
import st from './Phone.module.css';

type PhoneProps = {
  phone: string;
  isDetailed?: boolean;
};

const Phone: FC<PhoneProps> = ({ isDetailed = false, phone }) => (
  <p
    x-ms-format-detection="none"
    className={isDetailed ? st.phoneDetailed : st.phone}
  >
    {phone}
  </p>
);

export default Phone;
